import React, { useState } from 'react'
import { getImages } from '../Common/const'
import Slider from "react-slick";
import MyVehicleForm from '../Common/MyVehicleForm';
import GetQuoteModal from '../Common/GetQuoteModal';
import ModalLayout from '../Common/ModalLayout';
import EnterVehicleInfoForm from '../Components/WeBuyExotics/EnterVehicleInfoForm';
import UseScrollReveal from '../Common/UseScrollReveal';
import SeoMeta from '../Common/SeoMeta';
const accordionData = [
  {
    id: 'one',
    header: 'Sell you Exotic with Ease',
    body: (
      <>
        Selling your owned or leased luxury vehicle on your own is typically time consuming and expensive once you’ve factored in back and forth negotiations, expert-level photograph, paid advertisements & of course test drive’s. We Buy Exotics makes it easy. All you have to do is enter your information online to get a real cash offer. That’s it.
      </>
    ),
    show: true
  },
  {
    id: 'two',
    header: 'Top of the line Service',
    body: (
      <>
        Top of the line Service
      </>
    ),
    show: false
  },
  {
    id: 'three',
    header: 'Our Values',
    body: (
      <>
        Our Values
      </>
    ),
    show: false
  },
  {
    id: 'four',
    header: 'Lorem ipsum dolor sit amet',
    body: (
      <>
        Lorem ipsum dolor sit amet
      </>
    ),
    show: false
  },
  {
    id: 'five',
    header: 'Lorem ipsum dolor sit amet',
    body: (
      <>
        Lorem ipsum dolor sit amet
      </>
    ),
    show: false
  }
];
const WeBuyExotics = () => {
  const optionssl = {
    slidesToShow: 4,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 768, // mobile devices
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        }
      },
      {
        breakpoint: 1024, // tablets
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
        }
      }
    ]
  };
  const [activeAccordion, setActiveAccordion] = useState(
    accordionData.find(item => item.show)?.id || accordionData[0].id
  );
  
  const [selectedValue, setSelectedValue] = useState("");
  const [getQuoteModal, setGetQuoteModal] = useState(false);
  const closeGetQuoteModal = () => {
      setGetQuoteModal(false)
  }
  const [openDragDropModal, setopenDragDropModal] = useState(false);
  const [previewURL, setPreviewURL] = useState(null);
  console.log("openDragDropModal", openDragDropModal)
  console.log("previewURL", previewURL)
  const closeDragDropModal = () => {
      setopenDragDropModal(false)
  }
  const [files, setFiles] = useState([]);
  UseScrollReveal();
  return (
    <>
      <SeoMeta
          title="We Buy Exotics"
          description=""
          keywords=""
          ogTitle="We Buy Exotics"
          ogDescription=""
      />
      <section className='wbe-wrap pt-140'
        style={{
          backgroundImage: `url(${getImages('wbe-hero.webp')})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
        }}
      >
        <div className='container'>
          <div className='d-flex align-items-center justify-content-between wbe-banner-flex'>
            <div className='wow wbe-banner-left reveal fadeInLeft'>
              <div>
                <h1 className='lg-title font-4-3em fw-700 text-uppercase mb-3'>We Buy Exotics</h1>
                <div className='lg-title font-1-9em text-uppercase'>The Fastest & Safest Way To Sell <br />Your Exotic Car</div>
              </div>
            </div>
            <div className='wbe-box wow reveal fadeInRight'>
              <div className='sm-title font-1-3em text-uppercase fw-300 eurostile mb-4'>Enter Vehicle Info</div>
              <EnterVehicleInfoForm/>
            </div>
          </div>
        </div>
      </section>
      <section className='wbe-achive-wrap wow reveal fadeInUp'>
        <div className='row align-items-center wbea-flex'>
          <div className='col-lg-4 text-center'>
            <div className='d-inline-flex align-items-center text-start'>
              <div className='lg-title font-4-3em fw-700'>50</div>
              <div className='sm-title font-1-2em ps-4'>Serving all 50 States</div>
            </div>
          </div>
          <div className='col-lg-4 text-center'>
            <div className='d-inline-flex align-items-center text-start'>
              <div className='lg-title font-4-3em fw-700'>900</div>
              <div className='sm-title font-1-2em ps-4'>Over 900+ 5-Star <br />Google Reviews</div>
            </div>
          </div>
          <div className='col-lg-4 text-center'>
            <div className='d-inline-flex align-items-center text-start'>
              <div className='lg-title font-4-3em fw-700'>10k</div>
              <div className='sm-title font-1-2em ps-4'>Clients served <br />throughout the US</div>
            </div>
          </div>
        </div>
      </section>
      <section className='wbe-process-wrap d-md-flex align-items-center'>
        <div className='w-50 wow wp-left reveal fadeInLeft'>
          <img src={getImages('easy-process-image.webp')} />
        </div>
        <div className='w-50 ps-md-5 pe-md-5 wp-right'>
          <div className='sm-title text-uppercase font-2-5em mb-4 wow reveal fadeInUp'>Easy Process</div>
          <ul className='oe-list-flex'>
            <li className='w-100 mb-3 wow reveal fadeInUp'>
              <div className='d-flex align-items-center'>
                <div className='oe-icon'>
                  <img src={getImages('arrow.svg')} />
                </div>
                <div className='sm-title eurostile text-uppercase pt-1'>Submit Your Information</div>
              </div>
            </li>
            <li className='w-100 mb-3 wow reveal fadeInUp'>
              <div className='d-flex align-items-center'>
                <div className='oe-icon'>
                  <img src={getImages('arrow.svg')} />
                </div>
                <div className='sm-title eurostile text-uppercase pt-1'>Receive Your Offer</div>
              </div>
            </li>
            <li className='w-100 mb-3 wow reveal fadeInUp'>
              <div className='d-flex align-items-center'>
                <div className='oe-icon'>
                  <img src={getImages('arrow.svg')} />
                </div>
                <div className='sm-title eurostile text-uppercase pt-1'>Receive Your Offer</div>
              </div>
            </li>
            <li className='w-100 mb-3 wow reveal fadeInUp'>
              <div className='d-flex align-items-center'>
                <div className='oe-icon'>
                  <img src={getImages('arrow.svg')} />
                </div>
                <div className='sm-title eurostile text-uppercase pt-1'>We Schedule the Pick-Up</div>
              </div>
            </li>
          </ul>
          <div className='mt-4 wow reveal fadeInUp'>
            <button type='submit' className='orange-white-btn fw-700 text-uppercase lg-btn px-5'>We Schedule the Pick-Up</button>
          </div>
        </div>
      </section>
      <section className='customer-served-wrap'>
        <div className='container'>
          <div className='xxl-title fw-300 text-uppercase wow reveal fadeInUp'><span className='text-orange'>10,000+</span> customers served in all <span className='text-orange'>50</span> <br />states with 900+ <span className='text-orange'>5-star</span> ratings.</div>
          <div className='mt-70 wow reveal fadeInUp'>
            <Slider {...optionssl} className='wbecs-slider'>
              <div>
                <div className='wbe-cs-box'>
                  <div className='d-flex align-items-center justify-content-between mb-2'>
                    <div className='d-flex align-items-center'>
                      <div className='wbe-cs-circle' style={{ backgroundColor: '#512da8' }}>R</div>
                      <div className='ps-3'>
                        <div className='xs-title font-bold text-black helvetica'>Rick Hart</div>
                        <div className='xs-title font-13 opacity-0-3 font-600 text-black helvetica-neue'>January 31, 2024</div>
                      </div>
                    </div>
                    <div className='g-icon'>
                      <img src={getImages('icon.svg')} />
                    </div>
                  </div>
                  <div className='wbe-cs-rating mb-2'>
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block verify-icon ms-2' src={getImages('ti-verified.svg')} />
                  </div>
                  <div className='mb-1 wbe-cs-content'>
                    <p>What an amazing experience!!! Everyone was so nice to work with and was out of there from start to finish (money in hand)</p>
                  </div>
                  <div>
                    <a href='#' className='wbe-read-more'>Read more</a>
                  </div>
                </div>
              </div>
              <div>
                <div className='wbe-cs-box'>
                  <div className='d-flex align-items-center justify-content-between mb-2'>
                    <div className='d-flex align-items-center'>
                      <div className='wbe-cs-circle' style={{ backgroundColor: '#ef64a2' }}>B</div>
                      <div className='ps-3'>
                        <div className='xs-title font-700 text-black helvetica'>Bobby Smith</div>
                        <div className='xs-title font-13 opacity-0-3 font-600 text-black helvetica-neue'>January 31, 2024</div>
                      </div>
                    </div>
                    <div className='g-icon'>
                      <img src={getImages('icon.svg')} />
                    </div>
                  </div>
                  <div className='wbe-cs-rating mb-2'>
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block verify-icon ms-2' src={getImages('ti-verified.svg')} />
                  </div>
                  <div className='mb-1 wbe-cs-content'>
                    <p>What an amazing experience!!! Everyone was so nice to work with and was out of there from start to finish (money in hand)</p>
                  </div>
                  <div>
                    <a href='#' className='wbe-read-more'>Read more</a>
                  </div>
                </div>
              </div>
              <div>
                <div className='wbe-cs-box'>
                  <div className='d-flex align-items-center justify-content-between mb-2'>
                    <div className='d-flex align-items-center'>
                      <div className='wbe-cs-circle' style={{ backgroundColor: '#a8562d' }}>J</div>
                      <div className='ps-3'>
                        <div className='xs-title font-700 text-black helvetica'>John Digges</div>
                        <div className='xs-title font-13 opacity-0-3 font-600 text-black helvetica-neue'>January 31, 2024</div>
                      </div>
                    </div>
                    <div className='g-icon'>
                      <img src={getImages('icon.svg')} />
                    </div>
                  </div>
                  <div className='wbe-cs-rating mb-2'>
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block verify-icon ms-2' src={getImages('ti-verified.svg')} />
                  </div>
                  <div className='mb-1 wbe-cs-content'>
                    <p>What an amazing experience!!! Everyone was so nice to work with and was out of there from start to finish (money in hand)</p>
                  </div>
                  <div>
                    <a href='#' className='wbe-read-more'>Read more</a>
                  </div>
                </div>
              </div>
              <div>
                <div className='wbe-cs-box'>
                  <div className='d-flex align-items-center justify-content-between mb-2'>
                    <div className='d-flex align-items-center'>
                      <div className='wbe-cs-circle' style={{ backgroundColor: '#ef64a2' }}>E</div>
                      <div className='ps-3'>
                        <div className='xs-title font-700 text-black helvetica'>Edward</div>
                        <div className='xs-title font-13 opacity-0-3 font-600 text-black helvetica-neue'>January 31, 2024</div>
                      </div>
                    </div>
                    <div className='g-icon'>
                      <img src={getImages('icon.svg')} />
                    </div>
                  </div>
                  <div className='wbe-cs-rating mb-2'>
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block star-icon' src={getImages('star.svg')} />
                    <img className='d-inline-block verify-icon ms-2' src={getImages('ti-verified.svg')} />
                  </div>
                  <div className='mb-1 wbe-cs-content'>
                    <p>What an amazing experience!!! Everyone was so nice to work with and was out of there from start to finish (money in hand)</p>
                  </div>
                  <div>
                    <a href='#' className='wbe-read-more'>Read more</a>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
          <div className='text-center mt-5 wow reveal fadeInUp'>
            <a href='#' className='orange-white-btn fw-700 text-uppercase lg-btn px-5 d-inline-block w-330'>Read Reviews</a>
          </div>
        </div>
      </section>
      <section className='faqs-wrap'>
        <div className='container'>
          <div className='xxl-title font-3-9em text-uppercase mb-5 wow reveal fadeInUp'>We Buy Exotics offers</div>
          <div className="accordion wbe-accordion" id="accordionExample">
            {accordionData.map((item, idx) => (
              <div
                className={`accordion-item  wow reveal fadeInUp ${activeAccordion === item.id ? ' active' : ''}`}
                key={item.id}
              >
                <h2 className="accordion-header" id={`heading${item.id}`}>
                  <button
                    className={`accordion-button w-100 d-flex align-items-center justify-content-between ${!item.show ? ' collapsed' : ''}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${item.id}`}
                    aria-expanded={item.show ? 'true' : 'false'}
                    aria-controls={`collapse${item.id}`}
                    onClick={() => setActiveAccordion(item.id)}
                  >
                    <div>{item.header}</div>
                    <div>
                      <span className='wbe-acc-icon'></span>
                    </div>
                  </button>
                </h2>
                <div
                  id={`collapse${item.id}`}
                  className={`accordion-collapse collapse${item.show ? ' show' : ''}`}
                  aria-labelledby={`heading${item.id}`}
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    {item.body}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className='sell-trade-wrap'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-lg-5 ps-lg-5 pb-lg-0 pb-md-5 pb-4 wow reveal fadeInUp'>
              <img src={getImages('we-buy-exotic-logo.png')}/>
            </div>
            <div className='col-lg-7 sot-right'>
              <div className='xxl-title font-3em text-uppercase mb-4 px-md-0 px-5 text-start  wow reveal fadeInUp'>Sell or Trade your Exotic</div>
              <MyVehicleForm
                  setSelectedValue={setSelectedValue}
                  getQuoteModal={getQuoteModal}
                  setGetQuoteModal={setGetQuoteModal}
                  sotForm={true}
              />
            </div>
          </div>
        </div>
      </section>
      <section className='wbe-about-wrap'>
        <div className='container'>
          <div className='row mlr-60'>
            <div className='col-lg-6 mb-lg-0 mb-5 wow reveal fadeInLeft'>
              <div className='wbe-about-image'>
                <img src={getImages('we-know.webp')}/>
              </div>
              <div className='md-title font-2-5em text-orange eurostile fw-400 text-uppercase mt-lg-5 mt-4 mb-lg-4 mb-3'>We know what to do!</div>
              <div className='common-text'>
                <p>Our team at We Buy Exotics are industry experts. We focus on purchasing vehicles over $100,000. We specialize in high end cars like Lamborghini, Ferrari, Porsche, Bentley, Mclaren, Aston Martin, Rolls Royce, Maserati, Mercedes, BMW, Range Rover, and many other sports cars or supercars. We have all worked for the biggest franchise car dealerships in the industry at the Ultra-Highline Level with roughly 20 plus years of experience each. We are experts in being able to form valuations on car prices with extreme accuracy.</p>
                <p>EVERYONE knows how to buy their next car. However almost nobody knows how to sell their car, especially a Luxury or Exotic Car!</p>
                <p>The typical paths are either selling to a private party or going to the dealer so the can consign on their showroom. These both can be great options if you have TIME to WASTE on potential buyers that want to come look at the car just for a test drive. And if you have a payoff or the new buyer needs a loan, that is a WHOLE other story. For more information read through our Complete How-To Sell Your Exotic Car Guide.</p>
                <p>If you go to the dealer to sell your vehicle outright, they will likely not give you the true value of your car, their main goal is to sell you another new car. Or they’ll try to consign your car so they can list on autotrader so they can make profit with no risk on your luxury vehicles just so you can net the same amount you could have received initially!</p>
              </div>
            </div>
            <div className='col-md-6 wow reveal fadeInRight'>
              <div className='wbe-about-image'>
                <img src={getImages('ready-to-sell.webp')}/>
              </div>
              <div className='md-title font-2-5em text-orange eurostile fw-400 text-uppercase mt-lg-5 mt-4 mb-lg-4 mb-3'>Are you ready to sell?</div>
              <div className='common-text'>
                <p>In today’s world, nobody will buy a car without running a Carfax, so why would anyone not make sure they’re receiving the highest offer they can for the trade?</p>

                <p>The highline car market is a lot like the stock market, constant swings in prices based off supply & demand are changing every day. For the most part, if you’re looking to buy a car now, every day you can wait the better as typically the car will get cheaper. However, when selling, the same holds true, every day you wait to sell your car typically the value will continue to depreciate and the more you can lose.</p>

                <p>We encourage every one of our clients who are seriously ready to sell their car to call 5 other car dealers or car buyers and see what they’ll “write a check” for their vehicle TODAY and then contact us as we feel confident we can offer more. It’s an extremely SIMPLE transaction, you sell your car and we buy it, typically within less than 24 hours. We even buy leased cars. This will be the EASIEST CAR DEAL you’re ever done!</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ModalLayout open={getQuoteModal} close={closeGetQuoteModal} darkThemeCls='true' modalWidth={750}>
          <GetQuoteModal 
              selectedValue={selectedValue}
              close={closeGetQuoteModal}
              setopenDragDropModal={setopenDragDropModal}
              setPreviewURL={setPreviewURL}
              files={files}
              setFiles={setFiles}
          />
      </ModalLayout>
    </>
  )
}

export default WeBuyExotics